import React from 'react';
import { useShellStatus } from '../../layout';
import { orgFullName } from '../../layout/ShellStatus';
import { Icon } from '../../design/Icon';

/** "Leland Management" (the mockups' org card title and tree root); useOrgName gives the short name ("Leland"). */
export function useOrgFullName() {
  return orgFullName(useShellStatus().status);
}

/** The mockup's search field inside a card head (`label.global-search`). */
export function CardSearch({ value, onChange, placeholder, maxWidth = 340 }) {
  return (
    <label className="global-search" style={{ maxWidth }}>
      <Icon name="search" />
      <input type="search" placeholder={placeholder} aria-label={placeholder} value={value} onChange={(e) => onChange(e.target.value)} style={{ height: 32 }} />
    </label>
  );
}
